//import calendar
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import BootstrapTheme from "@fullcalendar/bootstrap";
import esLocale from '@fullcalendar/core/locales/es';
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";

import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import Breadcrumb from '../../components/Common/Breadcrumb';

import classnames from 'classnames';
import { useFormik } from "formik";
import {
    Card,
    Col,
    Container,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap";
import * as Yup from "yup";

import {
    addNewEvent as onAddNewEvent,
    updateEvent as onUpdateEvent
} from "../../store/actions";

import { BaseCustomModal, BaseCustomButton, GradientDecorationLine } from "../../shared";

//css
import "@fullcalendar/bootstrap/main.css";

//redux
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { BackButton } from "../../components/Common/BackButton";
import { ScheduledTestsSearchersCitec } from "../../components/Common/ScheduledTestsSearchersCitec";
import { ScheduledTestsSearchersMovil } from "../../components/Common/ScheduledTestsSearchersMovil";

export const LabCitecScheduledTests = (props) => {

    const [activeTab, setActiveTab] = useState('1'); // Cambia entre 2 perfiles 1, 2.

    const [finalArrayEvents, setfFinalArrayEvents] = useState();

    const profiletoggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const dispatch = useDispatch();

    const labType = localStorage?.getItem("lType") ? JSON.parse(localStorage?.getItem("lType") ?? `{"labType": '1' }`) : '0'

    const { labRequestCalendars } = useSelector(state => ({
        labRequestCalendars: state.labRequestCalendarReducer.labRequestCalendars,
    }), shallowEqual);

    useEffect(() => {
        const pool = labRequestCalendars.filter(element => element.calendaredKey !== 'Informe final real');

        setfFinalArrayEvents(pool.map((event) => (
            {
                ...event,
                date: event.datedAt,
                title: `${(event.calendaredKey === 'Inicio de trabajos') ? `I-${event.labRequest.code}` : (event.calendaredKey === 'Informe parcial') ? `P-${event.labRequest.code}` : (event.calendaredKey === 'Informe final programado') ? `F-${event.labRequest.code}` : ''}`,

                process: event.calendaredKey,
                leyend: event.labRequest.code,
                labType: event.labRequest.laboratory.name,
                state: event.labRequest.region.state,
                municipality: event.labRequest.region.municipality,
                color: '',
                display: '',
                textColor: '',
            }
        )))

    }, [labRequestCalendars])

    const [event, setEvent] = useState({});

    // events validation
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: (event && event.title) || "",
            category: (event && event.category) || "",
            process: (event && event.process) || "",
            leyend: (event && event.leyend) || "",
            labType: (event && event.labType) || "",
            state: (event && event.state) || "",
            municipality: (event && event.municipality) || "",
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Please Enter Your Event Name"),
            category: Yup.string().required("Please Select Your Category"),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                const updateEvent = {
                    id: event.id,
                    title: values.title,
                    classNames: values.category + " text-white",
                    start: event.start,
                };
                // update event
                dispatch(onUpdateEvent(updateEvent));
                validation.resetForm();
            } else {
                const newEvent = {
                    id: Math.floor(Math.random() * 100),
                    title: values["title"],
                    start: selectedDay ? selectedDay.date : new Date(),
                    className: values.category + " text-white",
                };
                // save new event
                dispatch(onAddNewEvent(newEvent));
                validation.resetForm();
            }
            setSelectedDay(null);
            toggle();
        },
    });

    const [modal, setModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const [selectedDay, setSelectedDay] = useState(0);
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        new Draggable(document.getElementById("external-events"), {
            itemSelector: ".external-event",
        });
    }, []);

    useEffect(() => {
        if (!modal && !isEmpty(event)) {
            setTimeout(() => {
                setEvent({});
                setIsEdit(false);
            }, 700);
        }
    }, [modal, event]);

    /**
     * Handling the modal state
     */
    const toggle = () => {
        if (modal) {
            setModal(false);
            setEvent(null);
            setIsEdit(false);
        } else {
            setModal(true);
        }
    };

    /**
     * Handling click on event on calendar
     */
    const handleEventClick = (arg) => {
        const event = arg.event;
        setEvent({
            id: event.id,
            title: event.title,
            process: event._def.extendedProps.calendaredKey,
            leyend: event._def.extendedProps.leyend,
            labType: event._def.extendedProps.labType,
            state: event._def.extendedProps.state,
            municipality: event._def.extendedProps.municipality,
        });
        setIsEdit(true);
        toggle();
    };

    const buttons = (
        <BaseCustomButton
            color="primary"
            onClick={toggle}
            label="Aceptar"
            className="me-4"
            outline
        />
    );

    const title = (
        <div className="d-flex ms-3 p-0">
            <label className="m-0 p-0">
                <h4 className="text-primary m-0 ps-3">Detalles del evento</h4>
            </label>
        </div>
    );

    const renderEventContent = (eventInfo) => {
        return (
          <div style={{
            whiteSpace: "normal",
            overflow: "visible",
            display: "block"
          }}>
            {eventInfo.timeText && <span>{eventInfo.timeText} </span>}
            <span>{eventInfo.event.title}</span>
          </div>
        );
      };
      

    return (
        <React.Fragment>

            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <div className='d-flex justify-content-between'>
                                {
                                    labType === 'CITEC' ?
                                        <Breadcrumb breadcrumbItem1='labCitec' breadcrumbItem2='labCitecScheduledTests' /> : <Breadcrumb breadcrumbItem1='labMoviles' breadcrumbItem2='labCitecScheduledTests' />
                                }
                                <BackButton props={props} />
                            </div>

                            <Card className='' style={{ padding: 20 }}>

                                <Nav tabs className="nav-tabs-custom nav-justified">

                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { profiletoggle('1'); }}
                                        >
                                            Servicios Laboratorio Citec
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { profiletoggle('2'); }}
                                        >
                                            Servicios Laboratorio Móvil
                                        </NavLink>
                                    </NavItem>

                                </Nav>

                                <TabContent activeTab={activeTab} className="p-4">

                                    <TabPane tabId="1">

                                        <ScheduledTestsSearchersCitec activeTab={activeTab} />
                                        <div className="pt-4 px-5">
                                            {
                                                (activeTab === '1')
                                                    ?
                                                    <FullCalendar
                                                        locale={esLocale}
                                                        plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                                                        slotDuration={"00:15:00"}
                                                        handleWindowResize={true}
                                                        themeSystem="bootstrap"
                                                        headerToolbar={{
                                                            left: "prev,next today",
                                                            center: "title",
                                                            right: "dayGridMonth,dayGridWeek,dayGridDay",
                                                        }}
                                                        timeZone="UTC"
                                                        events={finalArrayEvents}
                                                        editable={true}
                                                        eventClick={handleEventClick}
                                                        eventContent={renderEventContent}
                                                        displayEventTime={false}
                                                    />
                                                    : ''
                                            }
                                        </div>


                                    </TabPane>

                                    <TabPane tabId="2">

                                        <ScheduledTestsSearchersMovil activeTab={activeTab} />
                                        <div className="pt-4 px-5">
                                            {
                                                (activeTab === '2')
                                                    ?
                                                    <FullCalendar
                                                        
                                                        plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                                                        slotDuration={"00:15:00"}
                                                        handleWindowResize={true}
                                                        themeSystem="bootstrap"
                                                        headerToolbar={{
                                                            left: "prev,next today",
                                                            center: "title",
                                                            right: "dayGridMonth,dayGridWeek,dayGridDay",
                                                        }}
                                                        timeZone="UTC"
                                                        events={finalArrayEvents}
                                                        editable={true}
                                                        eventClick={handleEventClick}
                                                        eventContent={renderEventContent}
                                                        displayEventTime={false}
                                                    />
                                                    : ''
                                            }
                                        </div>


                                    </TabPane>

                                </TabContent>

                                <BaseCustomModal
                                    title={title}
                                    isModalOpen={modal}
                                    handleCancel={toggle}
                                    zIndex={9999}
                                    className={props.className}
                                    footer={
                                        <Row className="d-flex justify-content-end mt-0">
                                            <Col className="col-6 text-end mb-3">{buttons}</Col>
                                        </Row>
                                    }
                                >
                                    <GradientDecorationLine />

                                    <Row>
                                        <Col className="col-12 mb-0 px-5">
                                            <ul>
                                                <li>
                                                    <h6>
                                                        <u>{validation.values.process}</u>
                                                    </h6>
                                                </li>
                                                <li>
                                                    <h6>{validation.values.leyend}</h6>
                                                </li>
                                                <li>
                                                    <h6>{validation.values.labType}</h6>
                                                </li>
                                                <li>
                                                    <h6>
                                                        <u>Estado:</u> {validation.values.state}
                                                    </h6>
                                                </li>
                                                <li>
                                                    <h6>
                                                        <u>Localidad:</u> {validation.values.municipality}
                                                    </h6>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Row>

                                    <GradientDecorationLine />
                                </BaseCustomModal>

                                <div id="external-events" className="mt-2">

                                </div>

                            </Card>

                        </Card>
                    </Col>
                </Container>
            </div>

        </React.Fragment>
    );
};

LabCitecScheduledTests.propTypes = {
    events: PropTypes.array,
    categories: PropTypes.array,
    className: PropTypes.string,
    onGetEvents: PropTypes.func,
    onAddNewEvent: PropTypes.func,
    onUpdateEvent: PropTypes.func,
    onDeleteEvent: PropTypes.func,
    onGetCategories: PropTypes.func,
};
